"use client";

import { c as _c } from "react/compiler-runtime";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./About.module.scss";
import { fetchAboutSectionFile } from "./about.helpers";
import { useEffect, useState } from "react";
export default function AboutReleaseNotes() {
  const $ = _c(5);
  const [html, setHtml] = useState("");
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      fetchAboutSectionFile("release_notes").then(setHtml);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Row><Col><h1>Release Notes</h1></Col></Row>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== html) {
    t3 = <Container>{t2}<Row className="pt-2"><Col className={styles.htmlContainer} dangerouslySetInnerHTML={{
          __html: html
        }} /></Row></Container>;
    $[3] = html;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}